import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../../data/blogData';
import ShinyText from '../ui/reactbits/ShinyText';

const BlogSection: React.FC = () => {

  return (
    <section id="blog" className="relative py-24 md:py-32 section-backdrop-light">

      <div className="section-grain" aria-hidden="true" />
      <div className="container relative mx-auto px-3 sm:px-4 lg:px-6">
        <div className="mb-16">
          <div className="flex items-center lg:hidden mb-3">
            <span className="font-mono text-xs tracking-widest text-foreground/60 mr-2">[ 08 ]</span>
            <div className="w-20 border-t-2 border-foreground" />
          </div>
          <div className="hidden lg:flex flex-row items-baseline">
            <span className="font-mono text-xs tracking-widest text-foreground/60 mr-6">[ 08 ]</span>
            <div>
              <div className="w-20 border-t-2 border-foreground mb-4"></div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-extrabold leading-tight">From Our Blog</h2>
            </div>
          </div>
          <div className="lg:hidden">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-extrabold leading-tight">From Our Blog</h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl ml-auto">
          {blogPosts.slice(0, 3).map((post) => (
            <Link 
              key={post.id} 
              to={`/blog/${post.categorySlug}/${post.slug}`}
              className="group block glow-card card-backdrop border-2 border-foreground animate-on-scroll transition-transform duration-200 hover:scale-[1.02] overflow-hidden cursor-pointer"
            >
              {/* Blog post image */}
              <div className="w-full h-48 bg-gray-200 relative overflow-hidden">
                {post.image ? (
                  <img 
                    src={post.image} 
                    alt={post.title}
                    width="600"
                    height="400"
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                    onError={(e) => {
                      // Fallback to gradient background if image fails to load
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      target.parentElement?.classList.add('bg-gradient-to-br', 'from-primary/10', 'to-primary/5');
                    }}
                  />
                ) : (
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-primary/5"></div>
                )}
              </div>
              
              {/* Blog post content */}
              <div className="p-6">
                {/* Category badge */}
                <div className="flex items-center mb-3">
                  <span className="inline-block bg-primary text-primary-foreground font-mono text-xs uppercase tracking-widest px-2 py-1 rounded">
                    {post.category}
                  </span>
                  <span className="text-foreground/40 ml-auto text-sm font-mono">{post.date}</span>
                </div>
                
                {/* Title and excerpt */}
                <h3 className="text-xl font-bold mb-3 leading-tight">
                  <ShinyText 
                    text={post.title} 
                    speed={2} 
                    className="text-foreground"
                  />
                </h3>
                <p className="text-sm text-foreground/70 mb-4 line-clamp-3">{post.excerpt}</p>
                
                {/* Read more link */}
                <span className="inline-flex items-center text-foreground hover:text-primary font-medium text-sm transition-colors duration-200">
                  READ ARTICLE →
                </span>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
};

export default BlogSection;

